// json中过滤出质检不通过项的相关逻辑,以公用：质检结果UI组件CheckResultTree、导出质检反馈的内容文案
import { isArray } from 'lodash-es';
import { message } from '@fuxi/eevee-ui';
import { formatCheckResult } from 'common/utils';
import { CommentStatus } from '@/types';
import { formatSize } from '@/utils/utils';
import { CheckMethodMap } from 'common/constants';

export const filterErrorFilesByType = (checkList, searchType) => {
  // 只展示错误的文件
  if (!isArray(checkList)) {
    return [];
  }
  if (!searchType) {
    return (
      checkList?.filter(
        ({ type, fileName, status }) => fileName && type !== 'DCCFile' && status === CommentStatus.NotPass,
      ) || []
    );
  }
  return checkList?.filter(({ type, status }) => type === searchType && status === CommentStatus.NotPass) || [];
};

export const getCheckShowTree = (checkList) => {
  // 将铺平结构checklist变成树状的文件层级
  // dccFile层级
  const dccFileTrees =
    filterErrorFilesByType(checkList, 'DCCFile').map((dccFile) => {
      const { rules } = dccFile;
      const materials = filterErrorFilesByType(checkList, 'Material')?.map((material) => {
        const { name } = material;
        return { ...material, showMessage: `${name}贴图材质命名不规范` };
      });
      const dccFileTree = {
        ...dccFile,
        rules: getResultText([...rules, ...materials]),
        group: filterErrorFilesByType(checkList, 'Group')?.map(({ rules, ...rest }) => {
          return { ...rest, rules: getResultText(rules) };
        }),
      };
      return dccFileTree;
    }) || [];
  const normalFiles =
    filterErrorFilesByType(checkList, '')?.map(({ rules, ...rest }) => {
      return { ...rest, rules: getResultText(rules) };
    }) || [];
  return [...dccFileTrees, ...normalFiles];
};

export const getResultText = (rules) => {
  const res = rules
    ?.filter((rule) => {
      const isOldJson = rule?.hasOwnProperty('outputValue');
      if (isOldJson) {
        return (
          !!rule?.outputValue &&
          !['TexDependency'].includes(rule?.ruleType || '') &&
          rule?.status === CommentStatus.NotPass
        );
      } else {
        return rule?.status === CommentStatus.NotPass;
      }
    })
    ?.map(({ ruleType, checkResult, showMessage, ruleLabel, status, checkMessage, checkMethod }) => {
      if (showMessage) return { status, tip: showMessage };

      if (ruleType === 'FileSize') {
        const sizeNum = checkMessage.replace(/[^\d]/g, '');
        const [padding] = checkMessage.split(sizeNum);
        const tip = padding + formatSize(sizeNum);
        return { status, tip };
      }
      const formatResult = formatCheckResult(ruleType, checkResult);
      // '${checkMethod}${checkValue}次'，分别替换${checkMethod}和${checkValue}对应的值
      let formatCheckMessage = checkMessage?.replace(/\${checkMethod}/g, '等于');
      formatCheckMessage = formatCheckMessage?.replace(/\${checkValue}/g, formatResult || '');
      const text = formatCheckMessage || formatResult;
      const tip = text ? `${ruleLabel || ruleType}： ${text}` : `${ruleLabel || ruleType}`;
      return {
        status,
        tip,
      };
    });
  return res || [];
};

export const parseCheckResultJSON = (jsonObject) => {
  let checkList: Array<any> = [];
  let errorInfo = '';
  try {
    checkList = jsonObject?.checkList;
  } catch (e) {
    message.error('质检结果解析失败，请联系平台管理员');
    checkList = [];
    errorInfo = '当前评论为系统自动生成，具体内容解析失败，请联系平台管理员处理';
  }
  return { checkList, errorInfo };
};
